import {
    ADDITIONAL_PAGE_OPTIONS,
    SAILS_BNT_STORAGE,
    SAILS_PARAM_INSURANCE,
    SAILS_PARAM_SALESCHANNEL,
    SAILS_PARAM_TRADE_IN,
} from '@vfde-fe/sails-constants';
import {
    getSessionStorageItemJson,
} from '@vfde-fe/sails_core';
import {
    APP,
    CONTAINER_TARIFF,
} from 'Constant';
import { SAILS_PARAM_HARDWAREONLY } from '../constants';
import {
    getHardwareOnlyFromDom,
    getInsuranceFromDom,
} from './domHelper';
import { getIsTauschbonusEligible } from './getIsTauschbonusEligible';
import { getIsTradeInEligible } from './getIsTradeInEligible';
import { SailsHardwareDetailsStorage } from '../interfaces/storage';

/**
 * Get insurance from session storage
 */
 export const getInsurance = (): boolean => {
    const storage = getSessionStorageItemJson<SailsHardwareDetailsStorage | null>(SAILS_BNT_STORAGE);

    return storage?.[SAILS_PARAM_INSURANCE] ?? storage?.[APP]?.[CONTAINER_TARIFF]?.[SAILS_PARAM_INSURANCE] ?? getInsuranceFromDom() ?? false;
};

/**
 * Get hardware only status from storage, URL or DOM
 */
export const getHardwareOnly = (): boolean => {
    const storage = getSessionStorageItemJson<SailsHardwareDetailsStorage | null>(SAILS_BNT_STORAGE);
    const deviceId = window[ADDITIONAL_PAGE_OPTIONS].deviceId;

    return storage?.[APP]?.[deviceId]?.[SAILS_PARAM_HARDWAREONLY] ?? getHardwareOnlyFromDom() ?? false;
};

/**
 * Get trade in setting
 */
export const getTradeIn = (): boolean => {
    const storage = getSessionStorageItemJson<SailsHardwareDetailsStorage | null>(SAILS_BNT_STORAGE);

    return getIsTradeInEligible(storage?.[SAILS_PARAM_SALESCHANNEL]) && storage?.[SAILS_PARAM_TRADE_IN] || false;
};

/**
 * Get tauschbonus setting
 */
export const getTauschbonus = (isTradeIn: boolean): boolean => {
    return getIsTauschbonusEligible() && isTradeIn;
};
